//
// Function in scope outside of module since when the callbacks are run the module may not be registered yet.
// The function will still be scoped inside our main RS IIFE, and thus not actually in the global JS namespace
//
function _registerSassExport(key, data) {

    var registry = _registerSassExport.registry = _registerSassExport.registry || {};

    if (registry[key]) {
        throw new Error(`Sass exported data with key ${key} has already been registered.`);
    }

    registry[key] = data;
}

//
// Module providing access to data exported from SASS scripts for consumption in JavaScript
//
rs.module("ui/framework/sass-exports", [],
    
    function () {

        var registry = _registerSassExport.registry || {};

        //
        // Lookup a data object by the key name it was registered with
        //
        function data(key) {

            if (!registry[key]) {
                throw new Error(`No SASS data with name ${key} has been registered.`);
            }

            return registry[key];
        }

        var exports = {
            data: data
        };

        return exports;
    }
);

